import { http, HttpResponse } from 'msw';
import { apiUrl } from '../apiUrl';
import { AccountApiPaths } from '../../../slices/account-api.slice';

const getSsoUrlQuery = http.get(apiUrl(AccountApiPaths.getSsoUrl), ({ request }) => {
    const url = new URL('https://www.example.com/redirect');
    const searchParams = new URL(request.url).searchParams;
    url.search = searchParams.toString();
    return HttpResponse.json({ redirectUri: url.toString() });
});

export const ssoHandlers = [getSsoUrlQuery];
